module.exports = __webpack_public_path__ + "img/samplea.0beb37a5.png";